<style>
  .menu-manage-tree .el-tree-node__content {
    border-bottom: 1px dashed #7dabda;
  }
  .menu-manage-tree .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .menu-manage-tree .el-select input {
    color: #666;
    border: 1px solid #aaa;
  }
</style>
<template>
  <scroll-right-frame>
    <div class="menu-manage-tree" style="padding: 6px;">
      <div style="margin: 8px;height: 36px; line-height: 36px;">
        <el-row :gutter="20" style="line-height: 32px;">
          <el-col :span="6">
            <el-select size="small" v-model="selectWebSite" placeholder="请选择站点" @change="onSelectSiteChange">
              <el-option v-for="webSite in webSites" :key="webSite.id" :label="webSite.name" :value="webSite.id"></el-option>
            </el-select>
          </el-col>
          <el-col v-if="selectWebSite" :span="6">
            <el-input size="mini" placeholder="输入菜单名称进行过滤" v-model="filterText"></el-input>
          </el-col>
          <el-col v-if="selectWebSite" :span="12">
            <el-button type="primary" size="mini" @click="copyMenuToSite">复制到指定站点</el-button>
            <el-button type="primary" size="mini" @click="resetMenuSerialNumber">重置菜单序号</el-button>
          </el-col>
        </el-row>
      </div>

      <div style="border: 1px solid #dcdfe6;">
        <el-tree
          v-if="selectWebSite"
          ref="myTree"
          :data="data"
          :props="defaultProps"
          node-key="id"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          :default-expanded-keys="['root']"
          show-checkbox
          @node-drag-start="handleDragStart"
          @node-drag-enter="handleDragEnter"
          @node-drag-leave="handleDragLeave"
          @node-drag-over="handleDragOver"
          @node-drag-end="handleDragEnd"
          @node-drop="handleDrop"
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag">
          <span
            class="custom-tree-node"
            slot-scope="{ node, data }">
            <span class="el-tree-node__label" :style="{ color: (data.showInLeftMenu === '1' ? '#606266' : 'red')}">{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" @click="addLeafNode(data)">添加子菜单</el-button>
              <el-button v-if="data.isLeaf === '0'" type="text" size="mini" @click="addParentNode(data)">添加目录</el-button>
              <el-button v-if="data.id" type="text" size="mini" @click="updateNode(data)">{{ data.isLeaf === '0' ? '修改目录' : '修改节点' }}</el-button>
              <el-button v-if="data.id" type="text" size="mini" @click="deleteNode(node, data)">{{ data.isLeaf === '0' ? '删除目录' : '删除节点' }}</el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div v-if="!selectWebSite" class="empty-choose">
        <img src="static/styles/images/choose.png">
        <br>
        <span class="empty-text">请选择站点</span>
      </div>

      <whaty-dialog :title="formTitle" :visible.sync="showFormDialog" width="660px" @yes-btn-click="handleFormYesBtn" v-loading="loading">
        <div class="popup-content-in">
          <div class="form-row form-pretitle">
            <div class="form-tit">菜单名称<i style="color: #ff0000">*</i></div>
            <div class="form-con">
              <div class="input-wrap">
                <input v-model.trim="formData.menuName" @input="checkMenuName" class="form-control" placeholder="请输入菜单名称">
                <label v-show="menuNameErr" style="color: #ff0000;">
                  <i class="el-icon-warning"></i>
                  必填且长度不得超过{{MAX_MENU_NAME_LENGTH}}个字
                </label>
              </div>
            </div>
          </div>
          <div class="form-row form-pretitle">
            <div class="form-tit">图标class</div>
            <div class="form-con">
              <div class="input-wrap">
                <el-select v-model="formData.icon" placeholder="请选择" filterable clearable size="mini" style="width: 100%;">
                  <el-option v-for="icon in iconList" :key="icon.iconClass" :label="icon.name" :value="icon.iconClass">
                    <div>
                      <span style="float: left; font-size: 20px;"><i :class="['mng', icon.iconClass]"></i></span>
                      <span style="float: left; margin-left: 10px;">{{ icon.name }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="form-row form-pretitle">
            <div class="form-tit" style="width: 20%;left: -28px;">在左侧菜单显示</div>
            <div class="form-con">
              <div class="input-wrap">
                <el-radio v-model="formData.showInLeftMenu" :label="'1'" border size="mini">是</el-radio>
                <el-radio v-model="formData.showInLeftMenu" :label="'0'" border size="mini">否</el-radio>
              </div>
            </div>
          </div>
          <div class="form-row form-pretitle" v-show="isMenu">
            <div class="form-tit">基础功能</div>
            <div class="form-con">
              <div class="input-wrap">
                <el-select
                  v-model="formData.baseCategoryGroupId" placeholder="选择类别" filterable clearable
                  @change="handleBaseCategoryGroupChange"
                  size="mini" style="width: 46%;">
                  <el-option v-for="bcg in baseCategoryGroupList" :key="bcg.id" :label="bcg.name" :value="bcg.id"></el-option>
                </el-select>
                <el-select
                  v-model="formData.baseCategoryId" placeholder="选择功能" filterable clearable
                  size="mini" style="width: 50%;">
                  <el-option v-for="bc in baseCategoryMap[formData.baseCategoryGroupId]" :key="bc.id" :label="bc.name" :value="bc.id"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </whaty-dialog>
      <whaty-dialog title="复制菜单到站点" :visible.sync="canCopyMenu" width="400px" @yes-btn-click="copyMenu">
        <el-form :inline="true">
          <el-form-item label="选择站点：">
            <el-select size="small" multiple v-model="copyToWebSite" placeholder="请选择站点" clearable>
              <template v-for="webSite in webSites">
                <el-option v-if="webSite.id !== selectWebSite" :key="webSite.id" :label="webSite.name" :value="webSite.id"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-form>
      </whaty-dialog>
    </div>
  </scroll-right-frame>
</template>
<script>
  import util from '../../libs/util'
  import WhatyDialog from '../../components/dialog/dialog.vue'
  import ScrollRightFrame from '../../components/scroll-right-frame.vue'

  export default {
    components: {
      ScrollRightFrame,
      WhatyDialog
    },
    name: 'menu-manage-tree',
    data() {
      return {
        selectWebSite: '',
        copyToWebSite: [],
        webSites: [],
        vm: null,
        loading: false,
        showFormDialog: false,
        canCopyMenu: false,
        formTitle: '新增子菜单',
        filterText: '',
        data: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        formType: '',
        formData: {},
        currentNodeData: {},
        gridList: [
//          {id: 1, name: 'course-课程列表'}
        ],
        baseCategoryGroupList: [], // 基础功能类别列表
        baseCategoryList: [], // 基础功能列表
        baseCategoryMap: {},
        iconList: [
          {name: 'icon-tree-operation-stroke', iconClass: 'icon-tree-operation-stroke'},
          {name: 'icon-tree-data-stroke', iconClass: 'icon-tree-data-stroke'},
          {name: 'icon-tree-recruit-stroke', iconClass: 'icon-tree-recruit-stroke'},
          {name: 'icon-tree-files-stroke', iconClass: 'icon-tree-files-stroke'},
          {name: 'icon-tree-teaching-stroke', iconClass: 'icon-tree-teaching-stroke'},
          {name: 'icon-tree-enroll-stroke', iconClass: 'icon-tree-enroll-stroke'},
          {name: 'icon-tree-exam-stroke', iconClass: 'icon-tree-exam-stroke'},
          {name: 'icon-tree-paper-stroke', iconClass: 'icon-tree-paper-stroke'},
          {name: 'icon-tree-student-stroke', iconClass: 'icon-tree-student-stroke'},
          {name: 'icon-bell-stroke', iconClass: 'icon-bell-stroke'},
          {name: 'icon-freeze-stroke', iconClass: 'icon-freeze-stroke'},
          {name: 'icon-tree-file-stroke', iconClass: 'icon-tree-file-stroke'},
          {name: 'icon-book-stroke', iconClass: 'icon-book-stroke'},
          {name: 'icon-tree-teacher', iconClass: 'icon-tree-teacher'},
          {name: 'icon-theme-stroke', iconClass: 'icon-theme-stroke'},
          {name: 'icon-tree-result-stroke', iconClass: 'icon-tree-result-stroke'},
          {name: 'icon-finance-stroke', iconClass: 'icon-finance-stroke'},
          {name: 'icon-degree-stroke', iconClass: 'icon-degree-stroke'},
          {name: 'icon-exam-mng-stroke', iconClass: 'icon-exam-mng-stroke'},
          {name: 'icon-admin-stroke', iconClass: 'icon-admin-stroke'},
          {name: 'icon-admin2-stroke', iconClass: 'icon-admin2-stroke'},
          {name: 'icon-arrange-flow-stroke', iconClass: 'icon-arrange-flow-stroke'},
          {name: 'icon-arrange-fixed-stroke', iconClass: 'icon-arrange-fixed-stroke'},
          {name: 'icon-addNewStudent', iconClass: 'icon-addNewStudent'},
          {name: 'icon-courseMng', iconClass: 'icon-courseMng'},
          {name: 'icon-addCourse', iconClass: 'icon-addCourse'},
          {name: 'icon-addStudent', iconClass: 'icon-addStudent'},
          {name: 'icon-addNewCourse', iconClass: 'icon-addNewCourse'},
          {name: 'icon-condition', iconClass: 'icon-condition'}
        ],
        isMenu: true, // 是否是菜单
        MAX_MENU_NAME_LENGTH: 30, // 菜单名称允许最大字数
        menuNameErr: false // 是否显示菜单名称错误信息
      }
    },
    computed: {},
    created() {
      this.loadWebSites()
      this.loadGridList()
      this.loadBaseCategoryGroupList()
      this.loadBaseCategoryList()
    },
    mounted() {
    },
    methods: {
      loadWebSites() { // 加载webSite
        util.ajax.post('/superAdmin/permissionManage/getAllWebSites').then((res) => {
          if (res.data.meta.errCode === 0) {
            this.webSites = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取站点数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取站点数据失败！'})
          console.error(err)
        })
      },
      loadGridList() { // 加载grid列表
        util.ajax.post('/superAdmin/permissionManage/getGridList').then((res) => {
          if (res.data.meta.errCode === 0) {
            this.gridList = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取grid数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取grid数据失败！'})
          console.error(err)
        })
      },
      loadBaseCategoryGroupList() { // 加载基础功能类别
        util.ajax.post('/superAdmin/baseCategoryGroupManage/getBaseCategoryGroupList').then((res) => {
          if (res.data.meta.errCode === 0) {
            this.baseCategoryGroupList = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取基础功能分类失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取基础功能分类失败！'})
          console.error(err)
        })
      },
      loadBaseCategoryList() { // 加载基础功能
        util.ajax.post('/superAdmin/baseCategoryManage/getBaseCategoryList').then((res) => {
          if (res.data.meta.errCode === 0) {
            this.baseCategoryList = res.data.data
            this.initBaseCategoryMap()
          } else {
            this.$notify.info({title: '提示', message: '获取基础功能列表失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取基础功能列表失败！'})
          console.error(err)
        })
      },
      initBaseCategoryMap() {
        for (let i = 0; i < this.baseCategoryList.length; i++) {
          let c = this.baseCategoryList[i]
          if (this.baseCategoryMap[c.groupId]) {
            this.baseCategoryMap[c.groupId].push(c)
          } else {
            this.baseCategoryMap[c.groupId] = []
            this.baseCategoryMap[c.groupId].push(c)
          }
        }
      },
      handleBaseCategoryGroupChange() {
        this.baseCategoryList = []
        this.$set(this.formData, 'baseCategoryId', '')
      },
      onSelectSiteChange() { // 选择站点后加载站点的菜单数据
        this.loadTreeData()
      },
      loadTreeData() { // 加载站点的菜单数据
        let params = {webSiteId: this.selectWebSite}
        util.ajax.post('/superAdmin/permissionManage/menu/tree', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.data = [{
              id: 'root',
              name: '功能列表',
              children: res.data.data,
              expend: true,
              isLeaf: '0'
            }]
          } else {
            this.$notify.info({title: '提示', message: '获取菜单数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取菜单数据失败！'})
          console.error(err)
        })
      },
      filterNode(value, data) { // 搜索节点
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },
      addLeafNode(data) { // 添加叶子节点
        this.clearForm()
        this.currentNodeData = data
        this.formType = '1'
        this.showFormDialog = true
        this.formTitle = '新增子菜单'
        this.isMenu = true
      },
      addParentNode(data) { // 添加目录
        this.clearForm()
        if (data.isLeaf !== '0') {
          this.$notify.error({title: '错误', message: '操作非法, 叶子节点不允许该操作！'})
        }
        this.currentNodeData = data
        this.formType = '2'
        this.showFormDialog = true
        this.formTitle = '添加目录'
        this.isMenu = false
      },
      submitForm() { // 添加叶子节点——提交表单
//        if (!this.formData.menuName) {
//          this.$notify.error({title: '错误', message: '菜单名称不能为空'})
//          return
//        }
//        if (this.formData.menuCode && !/^[A-Za-z]/.test(this.formData.menuCode)) {
//          this.$notify.error({title: '错误', message: 'code格式不正确！英文字母开头，可以包含字母、数字、下划线'})
//          return
//        }
        let isLeaf = '0'
        if (this.formType === '1') {
          isLeaf = '1'
        }
        if (!this.formData.menuName) {
          this.menuNameErr = true
        }
        if (this.menuNameErr) {
          return
        }
        let params = {}
        let url = ''
        let op = ''
        if (this.formType === '1' || this.formType === '2') { // 添加
          params = {
            webSiteId: this.selectWebSite,
            parentId: this.currentNodeData.id,
            name: this.formData.menuName,
            icon: this.formData.icon,
            isLeaf: isLeaf,
            showInLeftMenu: this.formData.showInLeftMenu,
            extraParams: {
              baseCategoryGroupId: this.formData.baseCategoryGroupId,
              baseCategoryId: this.formData.baseCategoryId
            }
          }
          op = '添加'
          url = '/superAdmin/permissionManage/menu/addMenu'
        } else if (this.formType === '3') { // 修改
          params = {
            id: this.currentNodeData.id,
            name: this.formData.menuName,
            url: this.formData.menuUrl,
            code: this.formData.menuCode,
            gridId: this.formData.gridId,
            icon: this.formData.icon,
            showInLeftMenu: this.formData.showInLeftMenu,
            extraParams: {
              baseCategoryGroupId: this.formData.baseCategoryGroupId,
              baseCategoryId: this.formData.baseCategoryId
            }
          }
          op = '修改'
          url = '/superAdmin/permissionManage/menu/updateMenu'
        }
        this.loading = true
        util.ajax.post(url, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: op + '成功'})
            if (this.formType === '1' || this.formType === '2') { // 添加
              if (!this.currentNodeData.children) {
                this.$set(this.currentNodeData, 'children', [])
              }
              this.currentNodeData.children.push(res.data.data)
            } else {
              this.$set(this.currentNodeData, 'name', this.formData.menuName)
              this.$set(this.currentNodeData, 'url', this.formData.menuUrl)
              this.$set(this.currentNodeData, 'code', this.formData.menuCode)
              this.$set(this.currentNodeData, 'gridId', this.formData.gridId)
              this.$set(this.currentNodeData, 'icon', this.formData.icon)
              this.$set(this.currentNodeData, 'showInLeftMenu', this.formData.showInLeftMenu)
              this.$set(this.currentNodeData.extraParams, 'baseCategoryGroupId', this.formData.baseCategoryGroupId)
              this.$set(this.currentNodeData.extraParams, 'baseCategoryId', this.formData.baseCategoryId)
            }
            this.showFormDialog = false
            this.clearForm()
          } else {
            this.$notify.error({title: '错误', message: op + '失败，原因：' + res.data.meta.errMsg})
          }
          this.loading = false
        }).catch((err) => {
          this.$notify.error({title: '错误', message: op + '失败'})
          console.error(err)
          this.loading = false
        })
      },
      updateNode(data) { // 修改节点
        this.formData = {
          menuName: data.name,
          menuUrl: data.url,
          menuCode: data.code,
          gridId: data.gridId,
          icon: data.icon,
          baseCategoryGroupId: data.extraParams.baseCategoryGroupId,
          baseCategoryId: data.extraParams.baseCategoryId,
          showInLeftMenu: data.showInLeftMenu
        }
        this.currentNodeData = data
        this.formType = '3'
        this.showFormDialog = true
        this.formTitle = data.isLeaf === '0' ? '修改目录' : '修改节点'
        this.isMenu = data.isLeaf === '1' || false
        this.menuNameErr = false
      },
      deleteNode(node, data) { // 删除节点
        if (data.children && data.children.length > 0) {
          this.$notify.error({title: '错误', message: '该节点包含子节点，不能删除！请先删除子节点。'})
          return
        }
        this.$msgBox.showMsgBox({
          title: '提示',
          content: '确认删除' + data.name + '?',
          type: 'warning'
        }).then(() => {
          this.loading = true
          let params = {}
          params.params = {
            id: data.id
          }
          util.ajax.post('/superAdmin/permissionManage/menu/deleteMenu', params).then((res) => {
            if (res.data.meta.errCode === 0) {
              this.$notify.success({title: '成功', message: '删除成功'})
              this.$refs.myTree.remove(node.data.id)
            } else {
              this.$notify.error({title: '错误', message: res.data.meta.errMsg})
            }
            this.loading = false
          }).catch((err) => {
            this.$notify.error({title: '错误', message: '删除失败'})
            console.error(err)
            this.loading = false
          })
        }).catch(() => {
        })
      },
      handleFormYesBtn() {
        this.submitForm()
      },
      clearForm() {
        // 是否显示菜单名称错误信息默认是“否”
        this.menuNameErr = false
        // 是否在左侧菜单显示默认为"是"
        this.formData = {showInLeftMenu: '1'}
      },
      handleDragStart(node, ev) { // 节点开始拖拽时触发的事件
        // console.log('drag start', node)
      },
      handleDragEnter(draggingNode, dropNode, ev) { // 拖拽进入其他节点时触发的事件
        // console.log('tree drag enter: ', dropNode.label)
      },
      handleDragLeave(draggingNode, dropNode, ev) { // 拖拽离开某个节点时触发的事件
        // console.log('tree drag leave: ', dropNode.label)
      },
      handleDragOver(draggingNode, dropNode, ev) { // 在拖拽节点时触发的事件（类似浏览器的 mouseover 事件）
        // console.log('tree drag over: ', dropNode.label)
      },
      handleDragEnd(draggingNode, dropNode, dropType, ev) { // 拖拽结束时（可能未成功）触发的事件
        // console.log('tree drag end: ', dropNode && dropNode.label, dropType)
      },
      handleDrop(draggingNode, dropNode, dropType, ev) { // 拖拽成功完成时触发的事件
        let dragNodeId = draggingNode.data.id
        let dropNodeId = dropNode.data.id
        let params = {
          dragNodeId: dragNodeId,
          dropNodeId: dropNodeId,
          dropType: dropType
        }
        this.loading = true
        util.ajax.post('/superAdmin/permissionManage/menu/dragMenu', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '拖动成功'})
          } else {
            this.$notify.error({title: '错误', message: '拖动失败, 请刷新后重试'})
          }
          this.loading = false
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '拖动失败, 请刷新后重试'})
          console.error(err)
          this.loading = false
        })
      },
      allowDrop(draggingNode, dropNode) { // 拖拽时判定位置能否被放置
        return dropNode.data.id !== 'root'
      },
      allowDrag(draggingNode) { // 判断节点能否被拖拽
        return draggingNode.data.id !== 'root'
      },
      copyMenuToSite() {
        // 检测是否选择有菜单
        let nodes = this.$refs.myTree.getCheckedNodes()
        if (nodes && nodes.length > 0) {
          this.canCopyMenu = true
          this.copyToWebSite = []
        } else {
          this.$notify.warning({title: '警告', message: '请先选择菜单'})
        }
      },
      copyMenu() {
        // 获取选择的节点以及其父节点
        let nodeIds = this.$refs.myTree.getCheckedKeys()
        let halfNodeIds = this.$refs.myTree.getHalfCheckedKeys()
        util.pushAll(nodeIds, halfNodeIds)
        // 去掉root
        for (let i = nodeIds.length; i >= 0; i--) {
          if (nodeIds[i] === 'root') {
            nodeIds.splice(i, 1)
            break
          }
        }
        let params = {'fSiteId': this.selectWebSite, 'tSiteIds': this.copyToWebSite, 'ids': nodeIds}
        util.ajax.post('/superAdmin/permissionManage/doCopyMenuToOtherSite', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '复制菜单成功！'})
            this.loadTreeData()
            this.canCopyMenu = false
            this.copyToWebSite = []
          } else {
            this.$notify.error({title: '错误', message: res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '复制菜单失败'})
          console.error(err)
        })
      },
      checkMenuName() { // 检测菜单名称变化，显示错误信息
        let val = this.formData.menuName
        if (val && val.length < this.MAX_MENU_NAME_LENGTH) {
          this.menuNameErr = false
          return
        }
        this.menuNameErr = true
      },
      resetMenuSerialNumber() { // 重置菜单的序号
        this.$msgBox.showMsgBox({
          title: '确认',
          content: '如果数据库中菜单序号数据不正确，此操作可能会打乱目前的菜单顺序，您确定要执行此操作吗？',
          type: 'warning'
        }).then(() => {
          let params = {webSiteId: this.selectWebSite}
          util.ajax.post('/superAdmin/permissionManage/resetMenuSerialNumber', {params}).then((res) => {
            if (res.data.meta.errCode === 0) {
              this.$notify.success({title: '成功', message: '重置菜单序号成功！'})
              this.loadTreeData()
            } else {
              this.$notify.info({title: '提示', message: '重置菜单序号失败：' + res.data.meta.errMsg})
            }
          }).catch((err) => {
            this.$notify.error({title: '错误', message: '重置菜单序号失败！'})
            console.error(err)
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    watch: {
      filterText(val) {
        this.$refs.myTree.filter(val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/menu-manage/menu-manage-tree.vue